import React from 'react';
import LessonSection from './LessonSection';
import UnitSlideShowCards from './Cards/UnitSlideShowCards';
import type { SlideShow } from './Cards/UnitSlideShowCard/UnitSlideShowCardTypes';

interface NewUnitOverviewProps {
  overviewColor: string;
  programId: number;
  slideShowsAbove: SlideShow[];
  slideShowsBelow: SlideShow[];
  stafferId?: number;
  unitColor: string;
  unitId: number;
}

const NewUnitOverview = ({
  overviewColor,
  programId,
  slideShowsAbove,
  slideShowsBelow,
  stafferId,
  unitColor,
  unitId,
}: NewUnitOverviewProps) => (
  <>
    <UnitSlideShowCards
      overviewColor={overviewColor}
      programId={programId}
      slideShows={slideShowsAbove}
      stafferId={stafferId}
      unitId={unitId}
    />
    <LessonSection
      overviewColor={overviewColor}
      programId={programId}
      unitColor={unitColor}
      unitId={unitId}
    />
    <UnitSlideShowCards
      overviewColor={overviewColor}
      programId={programId}
      slideShows={slideShowsBelow}
      stafferId={stafferId}
      unitId={unitId}
    />
  </>
);

export default NewUnitOverview;
